module.exports = __webpack_public_path__ + "img/alish.a7e460d2.jpg";